import React from "react";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import MuiButton from "../../../components/basicComponent/MuiButton";

interface HotelOverviewCardProps {
  hotel: {
    HotelName?: string;
    address?: string;
    rating?: string;
    Description?: string;
    AvailableRoom?: any[];
  };
}

const HotelOverviewCard: React.FC<HotelOverviewCardProps> = ({ hotel }) => {
  const {
    HotelName = "Hotel Name Not Available",
    address = "Address not available",
    rating = "0",
    Description = "No description provided.",
    AvailableRoom = [],
  } = hotel;

  // Extract some unique features from AvailableRoom Meal info
  const uniqueFeatures = Array.from(
    new Set(
      AvailableRoom.flatMap((room) =>
        (room?.Meal || "")
          .split(",")
          .map((item: string) => item.trim())
      )
    )
  ).filter((item) => item); // Remove empty strings

  return (
    <div className="card mx-auto">
      {/* Header */}
      <div className="hotel-overview-header">
        <div className="d-flex justify-content-between align-items-center">
          <h1 className="hotel-title ps-2">{HotelName}</h1>
          <div className="rating-badge">
            <StarOutlinedIcon className="star-icon" />
            <span>{parseFloat(rating).toFixed(1)}</span>
          </div>
        </div>
      </div>

      {/* Address */}
      <div className="address-section">
        <LocationOnOutlinedIcon className="location-icon" />
        <p className="mb-0">{address}</p>
      </div>

      {/* Description */}
      <div className="card-body">
   
        {/* Highlights */}
        {uniqueFeatures.length > 0 && (
          <div className="row features-grid">
            {uniqueFeatures.slice(0, 6).map((feature, index) => (
              <div key={index} className="col-md-6 feature-item">
                <TaskAltOutlinedIcon className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HotelOverviewCard;
